import React, {useEffect, useState} from "react";
import {Box, Button, createTheme, Grid, MenuItem, Select, Skeleton, Stack, Typography,} from "@mui/material";
import {makeStyles} from "@mui/styles";

import {themeOptions} from "../../../theme";
import {ThemeProvider} from "@emotion/react";
import {useDispatch, useSelector} from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import TeamRankingTable from "../TeamRankingTable";
import {getAllTeamRanking} from "../../../redux/actions/team-ranking-action";
import {apiGet} from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import {CSVLink} from "react-csv";
import imgCsv from "../../../assets/images/download.png";
import SearchIcon from "@mui/icons-material/Search";

const useStyles = makeStyles((theme) => ({
    outlineInputBorder: {
        "& * > fieldset > legend": {
            display: "none",
        },
        "& > fieldset > legend > span": {
            display: "none",
        },
    },
    mainInput: {
        position: "relative",
    },
    inputField: {
        border: "1px solid #C4C4C4",
        borderRadius: "5px",
        fontSize: "14px !important",
        outline: "none",
        marginLeft: "4px",
        color: "#000",
        width: "100%",
        height: "100%",
        padding: "10px 0px 10px 35px",
        "&:focus": {
            border: "1px solid black",
        },
    },
    searchIcon: {
        color: "#C4C4C4",
        position: "absolute",
        top: "50%",
        left: "10px",
        transform: "translate(0,-50%)",
    }
}));

export default function TeamRankingList(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const theme = createTheme(themeOptions);
    const [leagueList, setLeagueList] = useState([]);
    const [leagueId, setLeagueId] = useState("");
    const [downloadCsvData, setDownloadCsvData] = useState([]);
    const [teamData, setTeamData] = useState([]);
    const [teamRankingData, setTeamRankingData] = useState([]);
    const [teamRanking, setTeamRanking] = useState([]);
    const [loading, setLoading] = useState(false);

    const getLeagueList = () => {
        setLoading(true);
        apiGet(
            `${ApiEndpoints.league.base}${ApiEndpoints.league.listleaguePOTY}`,
            (res) => {
                setLeagueList(res?.leagues);
                setLeagueId(res?.leagues[0]?._id);
            },
            (err) => {
            }
        );
    };

    // Ranking
    const rankingCal = (arr, pointSystem, scoreMultiplier) => {
        let tempArr = [];

        // Remove Empty Score Players
        for (let a = 0; a < arr.length; a++) {
            if (arr[a].projected) {
                tempArr.push(arr[a]);
            }
        }

        // Sort Position
        let rank = tempArr.map(
            (x, y, z) => z.filter((w) => w.projected.net < x.projected.net).length + 1
        );

        // Rank Calculation
        let rankingT = [...rank];
        for (let a = 0; a < tempArr.length; a++) {
            if (a === 0) {
                if (rank[a] === rank[a + 1]) {
                    rankingT[a] = `T${rank[a]}`;
                }
            }
            if (a > 0 && a < rank.length) {
                if (rank[a] === rank[a - 1] || rank[a] === rank[a + 1]) {
                    rankingT[a] = `T${rank[a]}`;
                }
            }
            if (a === tempArr.length - 1) {
                if (rank[a] === rank[a - 1]) {
                    rankingT[a] = `T${rank[a]}`;
                }
            }
        }

        // Points Calculation
        let points = [];
        for (let a = 0; a < tempArr.length; a++) {
            let counter = 0;
            let total = 0;
            let avg = 0;

            for (let b = 0; b < tempArr.length; b++) {
                if (tempArr[a].projected.net == tempArr[b].projected.net) {
                    counter += 1;
                    total +=
                        (pointSystem[0]?.point_system[b].value / 100) *
                        parseInt(scoreMultiplier);
                }
            }

            avg = parseFloat(total) / counter;

            points.push(avg);
        }

        return {
            points: points,
            rankingT: rankingT,
        }
    };

    const calculatePointsAndRank = (scores) => {
        if (scores?.data?.length > 0) {
            let rankWiseArr = [...scores?.data];

            rankWiseArr.sort(
                (a, b) =>
                    (a.projected != null ? a.projected.net : Infinity) -
                    (b.projected != null ? b.projected.net : Infinity)
            );

            // Player Positioning
            for (let j = 0; j < rankWiseArr.length - 1; j++) {
                if (rankWiseArr[j].projected) {
                    if (
                        rankWiseArr[j]?.projected?.net ===
                        rankWiseArr[j + 1]?.projected?.net
                    ) {
                        // LOGIC 1
                        let sum1 = 0;
                        let sum2 = 0;
                        for (let a = 17; a >= 9; a--) {
                            sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                            sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
                        }

                        sum1 = sum1 - rankWiseArr[j].playing_handicap / 2;
                        sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 2;

                        if (sum1 === sum2) {
                            // LOGIC 2
                            sum1 = 0;
                            sum2 = 0;

                            for (let a = 17; a >= 12; a--) {
                                sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                                sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
                            }

                            sum1 = sum1 - rankWiseArr[j].playing_handicap / 3;
                            sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 3;

                            if (sum1 === sum2) {
                                // LOGIC 3
                                sum1 = 0;
                                sum2 = 0;

                                for (let a = 17; a >= 15; a--) {
                                    sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                                    sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
                                }

                                sum1 = sum1 - rankWiseArr[j].playing_handicap / 6;
                                sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 6;

                                if (sum1 === sum2) {
                                    // LOGIC 4

                                    sum1 = 0;
                                    sum2 = 0;

                                    for (let a = 0; a <= 8; a++) {
                                        sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                                        sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
                                    }

                                    sum1 = sum1 - rankWiseArr[j].playing_handicap / 2;
                                    sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 2;

                                    if (sum2 < sum1) {
                                        let tempp = rankWiseArr[j];
                                        rankWiseArr[j] = rankWiseArr[j + 1];
                                        rankWiseArr[j + 1] = tempp;
                                        j = -1;
                                    }
                                } else {
                                    if (sum2 < sum1) {
                                        let tempp = rankWiseArr[j];
                                        rankWiseArr[j] = rankWiseArr[j + 1];
                                        rankWiseArr[j + 1] = tempp;
                                        j = -1;
                                    }
                                }
                            } else {
                                if (sum2 < sum1) {
                                    let tempp = rankWiseArr[j];
                                    rankWiseArr[j] = rankWiseArr[j + 1];
                                    rankWiseArr[j + 1] = tempp;
                                    j = -1;
                                }
                            }
                        } else {
                            if (sum2 < sum1) {
                                let tempp = rankWiseArr[j];
                                rankWiseArr[j] = rankWiseArr[j + 1];
                                rankWiseArr[j + 1] = tempp;
                                j = -1;
                            }
                        }
                    } else if (
                        rankWiseArr[j]?.projected?.net > rankWiseArr[j + 1]?.projected?.net
                    ) {
                        let tempp = rankWiseArr[j];
                        rankWiseArr[j] = rankWiseArr[j + 1];
                        rankWiseArr[j + 1] = tempp;
                        j = -1;
                    }
                }
            }

            const calculatedScoreAndPoints = rankingCal(rankWiseArr, scores?.pointsystem, scores?.points_multiplier);
            return {
                rankWiseArr: rankWiseArr,
                calculatedScoreAndPoints: calculatedScoreAndPoints
            };
        }

    }

    useEffect(async () => {
        dispatch(getAllTeamRanking(leagueId));

        apiGet(`${ApiEndpoints.tournament.getOnePoty}${leagueId}/status/completed`,
            async (resp) => {
                if (resp && resp?.tournaments) {
                    const tournamentsArray = Object.values(resp?.tournaments);
                    const promises = tournamentsArray.map(async (tournament) => {
                        return new Promise((resolve, reject) => apiGet(`${ApiEndpoints.leaderboard.base}${ApiEndpoints.leaderboard.getById}${tournament?._id}`,
                            async (response) => {
                                const newResponse = {
                                    tournament: tournament,
                                    leaderboard: response
                                }
                                resolve(newResponse);
                            },
                            (error) => {
                                reject(error)
                            }
                        ))
                    });
                    const allTournamentsPoints = [];
                    await Promise.all(promises.map(async (promise, index) => {
                        const response = await promise;
                        const data = calculatePointsAndRank(response.leaderboard);
                        if (teamData && teamData?.length > 0 && data) {
                            const filteredTeams = [];
                            teamData.forEach((team) => {
                                const teamPlayers = team.players;
                                const filteredPlayers = [];
                                data.rankWiseArr.forEach((player, index) => {
                                    const points = data.calculatedScoreAndPoints.points;
                                    const found = teamPlayers.find(p => p._id === player.user_id);
                                    if (found) {
                                        filteredPlayers.push({
                                            ...player,
                                            points: points[index]
                                        });
                                    }
                                });

                                const descendingTop6Players = filteredPlayers.sort((a, b) => b.points - a.points).slice(0, 6);
                                const keyToSum = 'points';
                                const teamTotalPoints = descendingTop6Players.reduce((acc, obj) => acc + obj[keyToSum], 0);

                                filteredTeams.push({
                                    players: descendingTop6Players,
                                    team: team,
                                    points: teamTotalPoints
                                });
                            });
                            if (filteredTeams.length === 0) console.log('No player found');

                            // console.log("Descending: ", descendingTop6);

                            allTournamentsPoints.push({
                                teamData: filteredTeams,
                                tournament: response.tournament
                            });

                        }
                    }));
                    // console.log("All tournaments data: ", allTournamentsPoints);

                    const totalTeamPoints = [];
                    teamData.map((team) => {
                        const teamPoints = [];
                        allTournamentsPoints.forEach((tournament) => {
                            const found = tournament.teamData.find((tournamentTeam) =>
                                tournamentTeam.team._id === team._id);
                            if (found) {
                                const points = isNaN(Number(found.points)) ? 0 : Number(found.points);
                                teamPoints.push(points);
                            }
                        });

                        const totalPoints = teamPoints.reduce((acc, obj) => acc + obj, 0);
                        // console.log(totalPoints);
                        totalTeamPoints.push({
                            ...team,
                            points: totalPoints
                        });
                    })

                    // Sort descending order
                    const teamRanking = totalTeamPoints.sort((a, b) => b.points - a.points);

                    const addedRankKey = teamRanking
                        .map((team, index) => ({
                            ...team,
                            rank: index + 1
                        }));
                    setTeamRanking(addedRankKey);
                    setTeamRankingData(addedRankKey);
                    setLoading(false);
                    // console.log(addedRankKey);
                }
            },
            () => {
            }
        )
    }, [dispatch, leagueId, teamData]);

    useEffect(() => {
        if (teamData?.length === 0) {
            apiGet(
                `${ApiEndpoints.teams.base}${ApiEndpoints.teams.all}`,
                (response) => {
                    setTeamData(response.teams);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [teamData]);

    useEffect(() => {
        if (leagueList.length === 0) {
            getLeagueList();
        }
    }, [leagueList]);

    useEffect(() => {
        if (loading === false) {
            buildCSVDataToDownload();
        }
    }, [loading, teamRankingData]);

    const buildCSVDataToDownload = () => {
        let tempArr = [];
        for (let i = 0; i < teamRankingData?.length; i++) {
            let tempObj = {
                Rank: teamRankingData[i]?.rank,
                Name: teamRankingData[i]?.name,
                No_of_Players: teamRankingData[i]?.players.length,
                Points: teamRankingData[i]?.points,
            };
            tempArr.push(tempObj);
        }
        setDownloadCsvData(tempArr);
    }

    const onSearchFilter = (value) => {
        const teamRanking = teamRankingData?.filter((val) => {
            if (
                val?.name?.toLowerCase().includes(value.toLowerCase()) ||
                val?.address?.toLowerCase().includes(value.toLowerCase())
            ) {
                return val;
            }
        });
        setTeamRanking(teamRanking);
    }

    return (
        <ThemeProvider theme={theme}>
            {/* { parent-container} */}
            <Grid container>
                <Grid item xs={12} p={3}>
                    {/* {container} */}
                    <Grid item container>
                        <Grid item xs={12} lg={4}>
                            <Typography variant="h6" fontWeight={"700"}>
                                Team Ranking
                            </Typography>
                        </Grid>
                        <Grid item xs={12} lg={8} container className={'d-flex align-items-end'}>
                            <Grid item xs={12} lg={3}>
                                <Box width={{xs: "100%", sm: "auto"}} className={'me-2'}>
                                    <CSVLink
                                        filename="team-ranking.csv"
                                        data={downloadCsvData}
                                        style={{
                                            width: "100%",
                                            textDecoration: "none",
                                        }}
                                    >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                padding: "6px",
                                            }}
                                            fullWidth
                                            endIcon={
                                                <img
                                                    src={imgCsv}
                                                    alt="Download Csv"
                                                    width="24px"
                                                    height="24px"
                                                />
                                            }
                                        >
                                            Download CSV
                                        </Button>
                                    </CSVLink>
                                </Box>
                            </Grid>
                            <Grid item xs={12} lg={5} marginTop={{xs: "20px", lg: 0}}>
                                <Stack className={'me-2'}>
                                    <Typography color={"#06623B"} fontWeight={"500"}>
                                        Please Select League
                                    </Typography>

                                    <Select
                                        variant="outlined"
                                        value={leagueId}
                                        selected
                                        className={classes.outlineInputBorder}
                                        label="."
                                        onChange={(e) => {
                                            setLoading(true);
                                            setLeagueId(e.target.value)
                                        }}
                                    >
                                        {
                                            leagueList.map((item, i) => {
                                                return (
                                                    <MenuItem
                                                        key={i}
                                                        value={item?._id}>
                                                        <Typography>{item?.name}</Typography>
                                                    </MenuItem>
                                                );
                                            })
                                        }
                                    </Select>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} lg={4}>
                                <Box className={classes.mainInput}>
                                    <SearchIcon className={classes.searchIcon}/>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className={classes.inputField}
                                        onChange={(e) => onSearchFilter(e.target.value)}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* {container} */}
                    <Grid item container>
                        {/* {container} */}
                        <Grid item xs={12} m={2}>
                            {loading === false ? (
                                <TeamRankingTable
                                    progressPending={loading}
                                    progressComponent={<CircularProgress color="success"/>}
                                    data={teamRanking || []}
                                />
                            ) : (
                                <>
                                    <Skeleton/>
                                    <Skeleton animation="wave"/>
                                    <Skeleton animation="wave"/>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ThemeProvider>
    );
}
